import React from "react";

const Footer = () => {
  return (
    <footer class="">
      <div class="w-full min-h-screen flex items-center justify-center bg-stone-950">
        <div
          class="md:w-2/3 w-full px-4 text-white flex flex-col "
          id="Contact"
        >
          <div class="w-full  font-bold">
            <h1 class="w-full md:w-2/3 text-7xl">
              How can we help you. get in touch
            </h1>

            <form class="mt-10">
              <label class="form-control w-full max-w-xs">
                <div class="label">
                  <span class="label-text text-white">Name</span>
                </div>
                <input
                  type="text"
                  placeholder="Type here"
                  class="input input-bordered w-full max-w-xs text-gray-600"
                  required
                />
              </label>

              <label class="form-control w-full max-w-xs mt-5">
                <div class="label">
                  <span class="label-text text-white">Email</span>
                </div>
                <input
                  type="email"
                  placeholder="Type here"
                  class="input input-bordered w-full max-w-xs  text-gray-600"
                  required
                />
              </label>

              <label class="form-control w-full max-w-xs mt-5">
                <div class="label">
                  <span class="label-text text-white">Message</span>
                </div>
                <textarea
                  placeholder="Type here"
                  class="textarea input-bordered w- max-w-md text-gray-600"
                  required
                ></textarea>
              </label>

              <div class="w-44 pt-6 md:pt-0 mt-10">
                <button
                  type="submit"
                  class="bg-red-500 justify-center text-center rounded-lg shadow px-10 py-3 flex items-center cursor-pointer"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>

          <div class="flex flex-col">
            <div class="flex mt-24 mb-12 flex-row justify-between">
              <a
                href="#about"
                class="hidden md:block cursor-pointer hover:text-gray-600text-white uppercase"
              >
                About
              </a>

              <a
                href="/Contact"
                class="hidden md:block cursor-pointer hover:text-gray-600 text-white uppercase"
              >
                Contact
              </a>
              <div class="flex flex-row space-x-8 items-center justify-between">
                <a href="https://github.com/Tumelo2748">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
                      fill="white"
                    />
                  </svg>
                </a>
                <a href="https://www.linkedin.com/in/selepe-thinane">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="24"
                    height="24"
                    viewBox="0 0 50 50"
                  >
                    <path
                      d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 41 6 C 42.668484 6 44 7.3315161 44 9 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 14 11.011719 C 12.904779 11.011719 11.919219 11.339079 11.189453 11.953125 C 10.459687 12.567171 10.011719 13.484511 10.011719 14.466797 C 10.011719 16.333977 11.631285 17.789609 13.691406 17.933594 A 0.98809878 0.98809878 0 0 0 13.695312 17.935547 A 0.98809878 0.98809878 0 0 0 14 17.988281 C 16.27301 17.988281 17.988281 16.396083 17.988281 14.466797 A 0.98809878 0.98809878 0 0 0 17.986328 14.414062 C 17.884577 12.513831 16.190443 11.011719 14 11.011719 z M 14 12.988281 C 15.392231 12.988281 15.94197 13.610038 16.001953 14.492188 C 15.989803 15.348434 15.460091 16.011719 14 16.011719 C 12.614594 16.011719 11.988281 15.302225 11.988281 14.466797 C 11.988281 14.049083 12.140703 13.734298 12.460938 13.464844 C 12.78117 13.19539 13.295221 12.988281 14 12.988281 z M 11 19 A 1.0001 1.0001 0 0 0 10 20 L 10 39 A 1.0001 1.0001 0 0 0 11 40 L 17 40 A 1.0001 1.0001 0 0 0 18 39 L 18 33.134766 L 18 20 A 1.0001 1.0001 0 0 0 17 19 L 11 19 z M 20 19 A 1.0001 1.0001 0 0 0 19 20 L 19 39 A 1.0001 1.0001 0 0 0 20 40 L 26 40 A 1.0001 1.0001 0 0 0 27 39 L 27 29 C 27 28.170333 27.226394 27.345035 27.625 26.804688 C 28.023606 26.264339 28.526466 25.940057 29.482422 25.957031 C 30.468166 25.973981 30.989999 26.311669 31.384766 26.841797 C 31.779532 27.371924 32 28.166667 32 29 L 32 39 A 1.0001 1.0001 0 0 0 33 40 L 39 40 A 1.0001 1.0001 0 0 0 40 39 L 40 28.261719 C 40 25.300181 39.122788 22.95433 37.619141 21.367188 C 36.115493 19.780044 34.024172 19 31.8125 19 C 29.710483 19 28.110853 19.704889 27 20.423828 L 27 20 A 1.0001 1.0001 0 0 0 26 19 L 20 19 z M 12 21 L 16 21 L 16 33.134766 L 16 38 L 12 38 L 12 21 z M 21 21 L 25 21 L 25 22.560547 A 1.0001 1.0001 0 0 0 26.798828 23.162109 C 26.798828 23.162109 28.369194 21 31.8125 21 C 33.565828 21 35.069366 21.582581 36.167969 22.742188 C 37.266572 23.901794 38 25.688257 38 28.261719 L 38 38 L 34 38 L 34 29 C 34 27.833333 33.720468 26.627107 32.990234 25.646484 C 32.260001 24.665862 31.031834 23.983076 29.517578 23.957031 C 27.995534 23.930001 26.747519 24.626988 26.015625 25.619141 C 25.283731 26.611293 25 27.829667 25 29 L 25 38 L 21 38 L 21 21 z"
                      fill="white"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
            <hr class="border-gray-600" />
            <p class="w-full text-center my-12 text-white">
              Copyright © 2024 Tumelo Thinane
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
